import {
  DateField,
  List,
  ListProps,
  Datagrid,
  EditButton,
  ShowButton,
  WithRecord,
  TextField,
  DeleteWithConfirmButton,
  TextInput,
} from "react-admin";
import { StandardPagination } from "../../common/StandardPagination";

export const ListInterviews: React.FC<ListProps> = (props) => {
  const filters = [
    <TextInput
      key="candidateName"
      label="Nombre del postulante"
      source="candidateName"
      alwaysOn
    />,
    <TextInput
      key="interviewerName"
      label="Nombre del entrevistador"
      source="interviewerName"
      alwaysOn
    />,
  ];

  return (
    <List
      {...props}
      perPage={10}
      filters={filters}
      sort={{ field: "interviewDate", order: "DESC" }}
      pagination={<StandardPagination />}
    >
      <Datagrid optimized>
        <TextField
          source="application.applicant.user.fullName"
          label="Postulante"
        />
        <TextField source="application.offer.title" label="Oferta" />
        <DateField source="interviewDate" label="Fecha de entrevista" />
        <TextField source="interviewer.fullName" label="Entrevistador" />

        <WithRecord
          render={(record) => {
            const candidateName = record?.application?.applicant?.user?.fullName || "N/A";
            const offerTitle = record?.application?.offer?.title || "N/A";
            const deleteTitle = `Eliminar entrevista: ${candidateName} - ${offerTitle}`;
            return (
              <>
                <ShowButton label="Ver" />
                <EditButton label="Editar" />
                <DeleteWithConfirmButton
                  mutationMode="pessimistic"
                  confirmTitle={deleteTitle}
                  confirmContent="¿Está seguro que desea eliminar esta entrevista? Esta acción no se puede deshacer."
                  record={record}
                  label="Eliminar"
                />
              </>
            );
          }}
        ></WithRecord>
      </Datagrid>
    </List>
  );
};
